import { useIntl } from '@/intl'
import { useState } from 'react'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    addLoad: translate({ id: 'order.form.bulk.loads.addLoadsModalTitle' }),
    maxLoadsReached: (maxSelectionsCount: number) =>
      translate({
        id: 'orders.edit.validation.loads.maxLoadsLimit',
        values: { maxSelectionsCount },
      }),
    emptyLoadName: translate({ id: 'orders.edit.validation.loads.emptyLoadName' }),
    newLoadWarningHeader: translate({ id: 'orders.edit.validation.loads.newLoadWarningHeader' }),
    newLoadWarningContent: translate({ id: 'orders.edit.validation.loads.newLoadWarning' }),
  }))

  return api
}
